import Reveal from "@/components/7fcc/Reveal";
import SectionHeader from "@/components/7fcc/SectionHeader";
import GhlSurvey from "@/components/7fcc/GhlSurvey";
import { QUIZ, SURVEY_EMBED } from "@/data/content";

// The point of action on the page. All CTAs smooth-scroll here (#qualify).
export default function QuizSection() {
  return (
    <section id="qualify" className="relative bg-ink-950 px-6 py-16 md:py-24" data-testid="quiz-section">
      <div
        aria-hidden="true"
        className="absolute left-1/2 top-1/2 h-[560px] w-[860px] max-w-full -translate-x-1/2 -translate-y-1/2 rounded-full bg-[radial-gradient(circle,rgba(61,126,255,0.07),transparent_65%)] blur-3xl"
      />
      <div className="relative mx-auto max-w-3xl">
        <div className="relative rounded-2xl border border-glowblue bg-ink-850/80 p-6 shadow-panel backdrop-blur-sm md:p-10 md:pb-8">
          <div
            className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-brand/60 to-transparent"
            aria-hidden="true"
          />
          <SectionHeader
            center
            eyebrow={QUIZ.eyebrow}
            title={QUIZ.headline}
            support={QUIZ.support}
            testId="quiz-heading"
          />
          <Reveal delay={0.15} className="mt-4 md:mt-6">
            <GhlSurvey
              src={SURVEY_EMBED.src}
              iframeId={SURVEY_EMBED.iframeId}
              title={SURVEY_EMBED.title}
              testId="ghl-survey"
            />
          </Reveal>
        </div>
      </div>
    </section>
  );
}
